import PropTypes from 'prop-types';
import React from 'react';
import { trackEvent } from 'dibs-tracking';
import get from 'lodash.get';
import { isPreview, getTrackingObj, getNoteByDevice } from './messageHelpers';
import style from './MessageBanner-style.scss';

const MessageBannerItem = props => {
    const { messageItem } = props;
    const { message, cta } = get(getNoteByDevice(messageItem), 'content', {});

    const _trackCtaClick = () => {
        if (!isPreview()) {
            trackEvent(
                getTrackingObj({
                    messageItem,
                    action: 'banner cta clicked'
                })
            );
        }
    };

    return (
        <div className={style.itemWrapper}>
            {message} {cta && <a className={style.ctaLink} href={cta.url} onClick={_trackCtaClick} target="_blank">{cta.text}</a>}
        </div>
    );
};

MessageBannerItem.propTypes = {
    messageItem: PropTypes.object.isRequired
};

export default MessageBannerItem;



// WEBPACK FOOTER //
// ./src/components/MessageBanner/MessageBannerItem.jsx